import { SVGProps, Ref, forwardRef } from 'react';

export const GraduationHatOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5.617 7.998 1l7.998 4.617-2.481 1.433c.132.681.155 1.419.158 2.025-.006 1.046-.07 2.483-.655 3.346-.263.388-.897.815-1.903 1.396-2.723 1.573-3.501 1.573-6.225 0-1.005-.58-1.64-1.008-1.902-1.396-.587-.864-.65-2.303-.655-3.35.003-.603.026-1.337.157-2.016zm3.793 2.19c-.046.415-.058.85-.06 1.265.003.505.02 1.042.094 1.535.078.518.199.85.319 1.028q-.001-.003.001 0c.013.015.094.105.33.275.26.186.621.41 1.114.694 1.379.797 1.955.992 2.412.992s1.033-.195 2.412-.992a14 14 0 0 0 1.113-.694c.237-.17.317-.26.33-.274l.002-.002c.12-.177.241-.51.319-1.025.074-.493.091-1.03.094-1.534a13 13 0 0 0-.06-1.273l-4.215 2.433zm4.205.811-5.198-3 5.198-3.001 5.198 3z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
GraduationHatOutlinedSize16Glyph.displayName = 'GraduationHatOutlinedSize16Glyph';
